import React, { useState, useEffect, useCallback } from 'react';
import styles from './InteractiveDiary.module.css';
import { useLanguage } from '../../context/LanguageContext';

// --- 导入图片资源 ---
import BACKGROUND_LEFT from '../../assets/images/diary/background1.png';
import BACKGROUND_RIGHT from '../../assets/images/diary/background2.png';
import DIARY_LOOK_1 from '../../assets/images/diary/wooden-diary-look1.webp';
import DIARY_LOOK_2 from '../../assets/images/diary/wooden-diary-look2.webp';
import DIARY_LOOK_3 from '../../assets/images/diary/wooden-diary-look3.webp';
import DIARY_LOOK_4 from '../../assets/images/diary/wooden-diary-look4.webp';

function InteractiveDiary() {
  const { t } = useLanguage();

  // 使用翻译的单页数据
  const diaryPages = [
    { id: 1, date: t('diary.page1Date'), image: DIARY_LOOK_1, description: t('diary.page1Left') },
    { id: 2, date: t('diary.page1Date'), image: DIARY_LOOK_2, description: t('diary.page1Right') },
    { id: 3, date: t('diary.page2Date'), image: DIARY_LOOK_3, description: t('diary.page2Left') },
    { id: 4, date: t('diary.page2Date'), image: DIARY_LOOK_4, description: t('diary.page2Right') },
    { id: 5, date: t('diary.page3Date'), image: DIARY_LOOK_1, description: t('diary.page3Left') },
    { id: 6, date: t('diary.page3Date'), image: DIARY_LOOK_3, description: t('diary.page3Right') },
  ];

  const [leftPageIndex, setLeftPageIndex] = useState(0);
  const [rightPageIndex, setRightPageIndex] = useState(1);
  const [isFlipping, setIsFlipping] = useState(false);
  const [flipDirection, setFlipDirection] = useState(''); // 'left' = 右翻到左, 'right' = 左翻到右

  const totalPages = diaryPages.length;
  const leftPage = diaryPages[leftPageIndex];
  const rightPage = diaryPages[rightPageIndex];

  // 预加载所有图片
  useEffect(() => {
    const imagesToPreload = [BACKGROUND_LEFT, BACKGROUND_RIGHT, DIARY_LOOK_1, DIARY_LOOK_2, DIARY_LOOK_3, DIARY_LOOK_4];
    imagesToPreload.forEach(src => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  // 向后翻页（点击右页）- 右页翻到左边
  const handleNextPage = useCallback(() => {
    if (isFlipping) return;

    setFlipDirection('left');
    setIsFlipping(true);

    setTimeout(() => {
      if (rightPageIndex >= totalPages - 1) {
        setLeftPageIndex(0);
        setRightPageIndex(1);
      } else {
        setLeftPageIndex(rightPageIndex);
        setRightPageIndex(rightPageIndex + 1);
      }
      setIsFlipping(false);
      setFlipDirection('');
    }, 600);
  }, [isFlipping, rightPageIndex, totalPages]);

  // 向前翻页（点击左页）- 左页翻到右边
  const handlePrevPage = useCallback(() => {
    if (isFlipping) return;

    setFlipDirection('right');
    setIsFlipping(true);

    setTimeout(() => {
      if (leftPageIndex <= 0) {
        setLeftPageIndex(totalPages - 2);
        setRightPageIndex(totalPages - 1);
      } else {
        setRightPageIndex(leftPageIndex);
        setLeftPageIndex(leftPageIndex - 1);
      }
      setIsFlipping(false);
      setFlipDirection('');
    }, 600);
  }, [isFlipping, leftPageIndex, totalPages]);

  return (
    <div className={styles.background}>
      <div className={styles.diaryBookWrapper}>

        {/* 左书壳 - background1.png 只有左半边有内容 */}
        <div
          className={`${styles.bookCover} ${styles.leftCover} ${isFlipping && flipDirection === 'right' ? styles.flipToRight : ''
            }`}
          onClick={handlePrevPage}
        >
          <img
            src={BACKGROUND_RIGHT}
            alt="Left cover"
            className={styles.coverImage}
          />
          {/* 左页内容 */}
          <div className={styles.pageContent}>
            <span className={styles.date}>{leftPage.date}</span>
            <div className={styles.imageContainer}>
              <img src={leftPage.image} alt="diary" />
            </div>
            <p className={styles.descriptionText}>{leftPage.description}</p>
          </div>
        </div>

        {/* 右书壳 - background2.png 只有右半边有内容 */}
        <div
          className={`${styles.bookCover} ${styles.rightCover} ${isFlipping && flipDirection === 'left' ? styles.flipToLeft : ''
            }`}
          onClick={handleNextPage}
        >
          <img
            src={BACKGROUND_LEFT}
            alt="Right cover"
            className={styles.coverImage}
          />
          {/* 右页内容 */}
          <div className={styles.pageContent}>
            <div className={styles.imageContainer}>
              <img src={rightPage.image} alt="diary" />
            </div>
            <span className={styles.date}>{rightPage.date}</span>
            <p className={styles.descriptionText}>{rightPage.description}</p>
          </div>
        </div>

        {/* 页码指示器 */}
        <div className={styles.pageIndicator}>
          <span>{leftPageIndex + 1}-{rightPageIndex + 1} / {totalPages}</span>
        </div>
      </div>
    </div>
  );
}

export default InteractiveDiary;